import studentsList from './components/studentsList.vue';

export default {
  routes: [
    {
      path: '/',
      component: studentsList,
      name: 'studentsList'
    },
  ]
};
